import { __assign } from "tslib";
import * as React from 'react';
import * as moment from 'moment-timezone';
import { useTranslation } from 'react-i18next';
import Events from '../Events/Events';
import Popper from '../UI/Popper/Popper';
var MonthlyCell = function (_a) {
    var hoverEventId = _a.hoverEventId, eventsListPopperPlace = _a.eventsListPopperPlace, events = _a.events, isTimeShown = _a.isTimeShown, popperPlacement = _a.popperPlacement, popperStyle = _a.popperStyle, time = _a.time, eventsListPopperStyle = _a.eventsListPopperStyle, timeFormat = _a.timeFormat, isMobile = _a.isMobile, cellHeight = _a.cellHeight, calendarWidth = _a.calendarWidth, isShrinking = _a.isShrinking, dateHeight = _a.dateHeight, handleEventTitleResize = _a.handleEventTitleResize, eventTitleHeight = _a.eventTitleHeight, eventTimeHeight = _a.eventTimeHeight, handleEventTimeResize = _a.handleEventTimeResize, eventHoverHandler = _a.eventHoverHandler, _b = _a.openPopup, openPopup = _b === void 0 ? null : _b, onEventExpanded = _a.onEventExpanded, _c = _a.onCopyClick, onCopyClick = _c === void 0 ? null : _c, _d = _a.onLocationClick, onLocationClick = _d === void 0 ? null : _d, _e = _a.onAttachmentClick, onAttachmentClick = _e === void 0 ? null : _e, handleShowMore = _a.handleShowMore, weekStarter = _a.weekStarter, timezone = _a.timezone, experiments = _a.experiments, localeToggle = _a.localeToggle, isStretchable = _a.isStretchable, locale = _a.locale, //temp
    privetEventsTitle = _a.privetEventsTitle;
    var t = useTranslation()[0];
    var _f = React.useState(false), isExpanded = _f[0], setIsExpanded = _f[1];
    var _g = React.useState(false), isShowMoreByEnter = _g[0], setIsShowMoreByEnter = _g[1];
    var cell = React.useRef(null);
    React.useEffect(function () {
        var handleKeyPress = function (event) {
            if (event.key === 'Enter') {
                setIsExpanded(false);
            }
        };
        window.addEventListener('keyup', handleKeyPress);
        return function () { return window.removeEventListener('keyup', handleKeyPress); };
    }, []);
    var handleShowMoreClick = function () {
        setIsExpanded(true);
        handleShowMore && handleShowMore();
    };
    var handleShowMoreEnter = function () {
        setIsShowMoreByEnter(true);
    };
    var closeExpandedEvents = function () { return setIsExpanded(false); };
    //FIXME:
    var cellDate = moment(time).format(t('Google_Calendar_Popover_Date'));
    if (locale === 'es') {
        //temp plaster
        cellDate = moment(time).format('D [de] MMMM');
    }
    var popperModifiers = {
        flip: {
            enabled: false,
        },
        preventOverflow: {
            enabled: true,
            boundariesElement: 'viewport',
        },
    };
    var eventsProps = {
        events: events,
        isTimeShown: isTimeShown,
        popperPlacement: popperPlacement,
        popperStyle: popperStyle,
        timeFormat: timeFormat,
        onCopyClick: onCopyClick,
        onLocationClick: onLocationClick,
        onAttachmentClick: onAttachmentClick,
        weekStarter: weekStarter,
        timezone: timezone,
        localeToggle: localeToggle,
        isStretchable: isStretchable,
        privetEventsTitle: privetEventsTitle,
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: cell },
            React.createElement(Events, __assign({}, eventsProps, { 
                //@ts-ignore
                handleShowMoreClick: handleShowMoreClick, calendarWidth: calendarWidth, isMobile: isMobile, cellHeight: cellHeight, isShrinking: isShrinking, dateHeight: dateHeight, eventTitleHeight: eventTitleHeight, handleEventTitleResize: handleEventTitleResize, eventTimeHeight: eventTimeHeight, handleEventTimeResize: handleEventTimeResize, hoverEventId: hoverEventId, eventHoverHandler: eventHoverHandler, cellDate: time, openPopup: openPopup, onEventExpanded: onEventExpanded, 
                //@ts-ignore
                handleShowMoreEnter: handleShowMoreEnter, experiments: experiments }))),
        React.createElement(Popper
        //@ts-ignore
        , { 
            //@ts-ignore
            modifiers: popperModifiers, placement: eventsListPopperPlace, open: isExpanded, title: cellDate, anchorEl: cell.current, popperStyle: eventsListPopperStyle, handleCloseClick: closeExpandedEvents, handleClickAway: closeExpandedEvents, calendarPopoverClass: "MonthlyCell", isMobile: isMobile, childrenDependencies: {}, isCloseFocused: isShowMoreByEnter },
            React.createElement(Events, __assign({ eventTitleHeight: undefined, eventTimeHeight: undefined, 
                //@ts-ignore
                eventPopperModifiers: popperModifiers, onEventExpanded: onEventExpanded, isMobile: isMobile, isSorted: true, isInPopper: true, experiments: experiments }, eventsProps)))));
};
export default MonthlyCell;
//# sourceMappingURL=MonthlyCell.js.map